import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import logoInteli from '../../../assets/images/Logo_inteli.png';
import neoLogo from '../../../assets/images/Neo_Logo_A.svg';

const FooterSection = () => {
  return (
    <footer style={{ 
      backgroundColor: '#11131a', 
      padding: '70px 0 20px', 
      borderTop: '2px solid rgba(0, 243, 255, 0.1)',
      color: '#e9ecef',
      position: 'relative'
    }}>
      <Container fluid className="px-4 px-xl-5">
        <Row className="mb-5 justify-content-between text-center text-md-start">
          <Col xs={12} md={6} lg={4} className="mb-5 mb-lg-0">
            <div className="mb-4 d-flex justify-content-center justify-content-md-start">
              <img 
                src={neoLogo} 
                alt="NeoApp Logo" 
                style={{ height: '35px', objectFit: 'contain', filter: 'brightness(0) invert(1)' }} 
              />
            </div>
            <p className="mx-auto mx-md-0" style={{ lineHeight: '1.6', fontSize: '0.95rem', maxWidth: '300px', color: '#e9ecef' }}>
              O <strong>NeoApp</strong> constrói o futuro da gestão esportiva, integrando tecnologia de ponta com inteligência artificial para o máximo em desempenho.
            </p>
          </Col>

          <Col xs={12} md={6} lg={4} xl={4} className="mb-5 mb-lg-0">
            <h5 className="text-uppercase mb-3" style={{ fontWeight: 'bold', letterSpacing: '1px', color: '#ffffff' }}>
              Contato
            </h5>
            <ul className="list-unstyled" style={{ fontSize: '0.95rem', lineHeight: '2' }}>
              <li className="d-flex align-items-center justify-content-center justify-content-md-start mb-2" style={{ wordBreak: 'break-word' }}>
                <div style={{
                  backgroundColor: 'rgba(0, 243, 255, 0.1)',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px',
                  flexShrink: 0
                }}>
                  <i className="mdi mdi-email-outline" style={{ color: '#00f3ff', fontSize: '1rem' }}></i>
                </div>
                comercial@intelitecnologia.com
              </li>
              <li className="d-flex align-items-center justify-content-center justify-content-md-start mb-2">
                <div style={{
                  backgroundColor: 'rgba(0, 243, 255, 0.1)',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '12px',
                  flexShrink: 0
                }}>
                  <i className="mdi mdi-phone-outline" style={{ color: '#00f3ff', fontSize: '1rem' }}></i>
                </div>
                (79) 99883-0315
              </li>
            </ul>
          </Col>

          <Col xs={12} md={12} lg={3} xl={3} className="text-center text-lg-start mt-4 mt-lg-0">
            <h5 className="text-uppercase mb-3" style={{ fontWeight: 'bold', letterSpacing: '1px', color: '#ffffff' }}>
              Empresa
            </h5>
            <ul className="list-unstyled" style={{ fontSize: '0.95rem', lineHeight: '2' }}>
              <li className="d-flex align-items-center justify-content-center justify-content-lg-start mb-2">
                <i className="mdi mdi-map-marker-outline me-2" style={{ color: '#00f3ff', fontSize: '1.2rem' }}></i>
                Aracaju - SE
              </li>
              <li className="d-flex align-items-center justify-content-center justify-content-lg-start mb-2">
                <i className="mdi mdi-domain me-2" style={{ color: '#00f3ff', fontSize: '1.2rem' }}></i>
                CNPJ: 60.180.850/0001-40
              </li>
            </ul>
          </Col>
        </Row>

        {/* Linha Divisória Inferior */}
        <div style={{ height: '1px', backgroundColor: 'rgba(255, 255, 255, 0.05)', marginTop: '30px', marginBottom: '20px' }}></div>

        {/* Rodapé de Copyright */}
        <Row className="align-items-center">
          <Col xs={12} md={6}>
            <p className="mb-md-0 mb-3 text-center text-md-start" style={{ fontSize: '0.85rem' }}>
              © {new Date().getFullYear()} NeoApp. Todos os direitos reservados.
            </p>
          </Col>
          <Col xs={12} md={6} className="d-flex justify-content-center justify-content-md-end align-items-center mt-3 mt-md-0">
            <span style={{ fontSize: '0.85rem', marginRight: '8px', color: '#e9ecef' }}>
              Desenvolvido por
            </span>
            <img 
              src={logoInteli} 
              alt="Ícone Intelitec" 
              style={{ height: '24px', opacity: '0.9', marginRight: '6px' }} 
            />
            <span style={{ fontSize: '0.95rem', fontWeight: 'bold', color: '#ffffff' }}>Intelitec</span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default FooterSection;
